<template>
  <div v-if="hasHistories" class="history-container">
    <h2 class="px-3 mx-0 my-0">ประวัติการใช้งาน</h2>
    <div v-if="histories.length > 0" class="activities mx-3 pt-3">
      <div
        v-for="(history, index) in histories"
        :key="index"
        class="activity mb-3"
      >
        <div class="date">{{ history.actionDate | moment-full }}</div>
        <div class="">
          <div>
            <span v-if="isAddRemoveAction(history.action)">{{
              inviterName(history.inviter)
            }}</span>
            <strong v-else>{{ inviterName(history.inviter) }}</strong>
            <span>{{ historyAction(history.action) }}</span>
          </div>
          <div v-if="isAddRemoveAction(history.action)">
            <strong
              >{{ history.invitee.firstName }}
              {{ history.invitee.lastName }}</strong
            >
            <span
              v-if="
                history.action === 'ADD' || history.action === 'ADD_BY_ADMIN'
              "
              >เป็น {{ activityStatus(history.role) }}</span
            >
            <span
              v-if="
                history.action === 'REMOVE' ||
                history.action === 'REMOVE_BY_ADMIN'
              "
              >จากการเป็น {{ activityStatus(history.role) }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div v-else class="activities p-3">ไม่มีประวัติการใช้งาน</div>
  </div>
</template>

<script>
import { isNil } from "ramda"
import { actionActivityHistory, memberActivityStatus } from "@/lib/mapper"

const DELETED_INVITER_NAME = "ผู้ใช้ที่ถูกลบ"

export default {
  props: {
    value: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    histories() {
      return this.value
    },
    // Null until a home is selected; an empty list still shows the panel with its empty-state text.
    hasHistories() {
      return !isNil(this.value)
    },
  },
  methods: {
    // The backend returns a null inviter when the admin or user who acted has since been deleted.
    inviterName(inviter) {
      if (isNil(inviter)) return DELETED_INVITER_NAME

      return `${inviter.firstName} ${inviter.lastName}`
    },
    isAddRemoveAction(action) {
      return (
        ["ADD", "REMOVE", "ADD_BY_ADMIN", "REMOVE_BY_ADMIN"].indexOf(action) !==
        -1
      )
    },
    historyAction(action) {
      return actionActivityHistory[action]
    },
    activityStatus(status) {
      return memberActivityStatus[status]
    },
  },
}
</script>

<style lang="scss" scoped>
.history-container {
  background: white;
  padding: 0;
  h2 {
    padding: 22px 0 23px 0;
    font-size: 16px;
    font-weight: bold;
    color: black;
    border-bottom: 1px solid#e0e0e0;
  }
}
.activities {
  font-size: 14px;
  color: #4a4a4a;
  overflow: auto;
  .date {
    font-size: 11px;
    font-weight: 500;
    color: #8c8786;
    margin-bottom: 2px;
  }
}
</style>
